import React, { useEffect, useRef } from "react";
import Countdown from "react-countdown";
import { HelperContext } from "../../store/helperStore";

const TestTimer = React.memo(function TestTimer({
  resp_time,
  dispatchHelper,
  handleAbtTOFin,
}) {
  // only renders if props have changed

  const { helperC } = HelperContext();
  const { isReplay, isAudioEnded, audioQuePlay, showingNumbers } = helperC;
  const timer = useRef(null);

  useEffect(() => {
    console.log("datadata isReplay", isReplay);
    if (!isReplay) {
      timer.current?.pause();
    } else {
      timer.current?.start();
    }
  }, [isReplay]);

  useEffect(() => {
    if(showingNumbers) {
      timer.current?.pause();
    } else {
      timer.current?.start();
    }
  }, [showingNumbers]);

  useEffect(() => {
    console.log("datadata audioQuePlay", audioQuePlay);
    if (audioQuePlay) {
      timer.current?.pause();
    }
  }, [audioQuePlay]);

  // useEffect(() => {
  //   console.log(isLoading);
  //   if (!isReplay) {
  //     timer.current.pause();
  //   }
  // }, [isLoading]);

  useEffect(() => {
    console.log(isAudioEnded);
    if (isAudioEnded) {
      timer.current?.start();
    }
  }, [isAudioEnded]);

  return (
    <Countdown
      date={Date.now() + resp_time * 1000}
      onTick={(data) => {
        data.total < 10000 ? handleAbtTOFin(true) : handleAbtTOFin(false);
      }}
      ref={timer}
      onComplete={() => {
        dispatchHelper({ type: "IS_AUDIO_ENDED", payload: false });
        dispatchHelper({
          type: "IS_NEXT_QUES",
          payload: true,
        });
      }}
      renderer={(props) => {
        const { minutes, seconds } = props;
        let mLen = minutes.toString();
        let sLen = seconds.toString();
        mLen = mLen.length;
        sLen = sLen.length;
        return (
          <p className="testTimer">
            {mLen <= 1 && "0"}
            {minutes}:{sLen <= 1 && "0"}
            {seconds}
          </p>
        );
      }}
    />
  );
});

export default TestTimer;
